import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription,
} from "@/components/ui/dialog";
import { Ban } from "lucide-react";

const MIN_LEN = 3;

export function CancelDialog({ open, onOpenChange, ticket, onConfirm, busy }) {
  const [reason, setReason] = useState("");

  const handleOpenChange = (v) => { if (!v) setReason(""); onOpenChange(v); };
  const confirm = async () => {
    if (reason.trim().length < MIN_LEN) return;
    await onConfirm(reason.trim());
    setReason("");
  };

  const tooShort = reason.trim().length > 0 && reason.trim().length < MIN_LEN;

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-[#DC2626]">
            <Ban className="w-5 h-5" /> Annuler le ticket {ticket?.full_ticket_code}
          </DialogTitle>
          <DialogDescription>
            Cette action est définitive et sera enregistrée dans le journal d'audit.
            Un motif d'au moins {MIN_LEN} caractères est requis.
          </DialogDescription>
        </DialogHeader>
        <div className="py-2">
          <Label className="text-sm">Motif d'annulation <span className="text-[#DC2626]">*</span></Label>
          <Textarea
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder="Ex: client parti, ticket erroné, demande client…"
            rows={3}
            data-testid="cancel-reason"
            autoFocus
          />
          {tooShort && (
            <div className="text-xs text-amber-600 mt-1" data-testid="cancel-reason-too-short">
              Minimum {MIN_LEN} caractères.
            </div>
          )}
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => handleOpenChange(false)}>Retour</Button>
          <Button onClick={confirm}
                  disabled={reason.trim().length < MIN_LEN || busy}
                  className="bg-[#DC2626] hover:bg-[#B91C1C]"
                  data-testid="cancel-confirm">
            Annuler le ticket
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
